import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { FacetListModule, ActiveFacetsModule, IconModule, ProductFacetNavigationModule, FacetModule, FacetListComponent, KeyboardFocusModule, AtMessageModule } from '@spartacus/storefront';
import { FacetListKbComponent } from './facet-list-kb/facet-list-kb.component';
import { FacetKbComponent } from './facet-kb/facet-kb.component';
import { FacetActiveKbComponent } from './facet-active-kb/facet-active-kb.component';
import { FacetNavigationComponent } from './facet-navigation/facet-navigation.component';
import { RouterModule } from '@angular/router';
/* import { SecureGuard } from 'src/app/services/Guards/SecurePassword/secure.guard'; */



@NgModule({
    imports: [
        CommonModule,
        FacetListModule,
        I18nModule,
        ProductFacetNavigationModule,
        FacetListModule,
        FacetModule,
        ActiveFacetsModule,
        RouterModule,
        IconModule,
        KeyboardFocusModule,
        UrlModule,
        AtMessageModule,
        ConfigModule.withConfig({
            cmsComponents: {
                ProductRefinementComponent: {
                    component: FacetNavigationComponent,
                    /* guards: [SecureGuard] */
                }
            }
        } as CmsConfig),
        FacetListKbComponent,
        FacetKbComponent,
        FacetActiveKbComponent,
        FacetNavigationComponent
    ],
    exports: [FacetNavigationComponent]
})
export class FacetNavigationModule { }
